import React from "react";
import { FormattedMessage } from "react-intl";

import Tooltip from "../../Tooltip";

import { Button, Wrapper } from "./styles";
import messages from "./messages";
import { IProps } from "./interfaces";

const TutorialButton = ({ onClick, setRef }: IProps) => {
    return (
        <Wrapper>
            <Tooltip label={<FormattedMessage {...messages.help} />} marginTop={8}>
                <Button onClick={onClick} ref={r => setRef && setRef(r)}>
                    <span>?</span>
                </Button>
            </Tooltip>
        </Wrapper>
    );
};

export default TutorialButton;
